<script>
	import { afterUpdate, onMount } from 'svelte'
	import { fade, slide, fly } from 'svelte/transition'
	import { gsap } from 'gsap'
	import BigPicture from 'bigpicture'
	import { ScrollTrigger } from 'gsap/ScrollTrigger'

	const jq = window.jQuery

	export let projects = []
	// console.log('projects:', projects)

	export let categories = []
	// console.log('categories:', categories)

	let activeProject, portfolioItems

	let activeCat = 'All'

	// $: console.log('activeCat:', activeCat)

	let html

	let shown = false

	//popup
	function openPopup(item) {
		activeProject = item
		shown = true
		html.classList.add('remove-page-scroll')
	}

	function closePopup() {
		shown = false
		html.classList.remove('remove-page-scroll')
	}

	//pagination
	function inArray(needle, haystack) {
		var length = haystack.length
		for (var i = 0; i < length; i++) {
			if (haystack[i] == needle) return true
		}
		return false
	}

	function arrayNext(array, currentItem, currentItemTax) {
		let filtered_array = []
		array.forEach((item) => {
			if (inArray(currentItemTax, item.taxonomies)) {
				filtered_array.push(item)
			}
		})
		let len = filtered_array.length
		let newIndex = filtered_array.indexOf(currentItem) + 1
		if (newIndex > len - 1) newIndex = 0
		return filtered_array[newIndex]
	}

	function arrayPrevious(array, currentItem, currentItemTax) {
		let filtered_array = []
		array.forEach((item) => {
			if (inArray(currentItemTax, item.taxonomies)) {
				filtered_array.push(item)
			}
		})
		let len = filtered_array.length
		let newIndex = filtered_array.indexOf(currentItem) - 1
		if (newIndex < 0) newIndex = len - 1
		return filtered_array[newIndex]
	}

	function nextSlide() {
		activeProject = arrayNext(projects, activeProject, activeCat)
		setTimeout(() => {
			bp()
		}, 100)
	}

	function previousSlide() {
		activeProject = arrayPrevious(projects, activeProject, activeCat)
		setTimeout(() => {
			bp()
		}, 100)
	}

	$: nextProject = arrayNext(projects, activeProject, activeCat)

	function bp() {
		let $blocksGallery = jq('.wp-block-gallery .wp-block-image > a')
		if ($blocksGallery.length) {
			// console.log('working')
			$blocksGallery.each(function (index, el) {
				el.setAttribute('data-bp', el.href)
			})

			$blocksGallery.on('click', function (e) {
				e.preventDefault()
				BigPicture({
					el: this,
					gallery: '.wp-block-gallery',
					loop: true,
					noLoader: true,
				})
			})
		}

		let $wpBlockImg = jq('.wp-block-image:not(.no-bp) > img')
		if ($wpBlockImg.length) {
			$wpBlockImg.on('click', function (e) {
				const $this = jq(this)
				const $imgEls = $this.find('img')
				e.preventDefault()
				BigPicture({
					el: $imgEls.length ? $imgEls[0] : this,
					imgSrc: this.href,
				})
			})
		}
	}

	//filtering
	let filteredProjects = projects
	let filterType = ''

	function applyFilter() {
		const now = new Date()
		const currentYear = now.getFullYear()

		filteredProjects = projects.filter((project) => {
			const postYear = new Date(project.timestamp * 1000).getFullYear()

			if (filterType === 'current') {
				return postYear === currentYear // Show posts from this year
			} else if (filterType === 'past') {
				return postYear < currentYear // Show only past years
			}
			return true // Show all if no filter
		})
	}

	onMount(() => {
		//filtering
		const params = new URLSearchParams(window.location.search)

		if (params.has('current')) {
			filterType = 'current'
		} else if (params.has('past')) {
			filterType = 'past'
		}

		applyFilter()

		// animations
		gsap.registerPlugin(ScrollTrigger)
		portfolioItems = document.querySelectorAll('.project-wrap')
		if (portfolioItems) {
			let port_tl = gsap.timeline({
				scrollTrigger: {
					trigger: '#projects-app',
					start: 'top center', // when the top of the trigger hits the center of the viewport
					// markers: true,
				},
			})

			let $filterWrap = document.querySelectorAll('.projects-filter-wrap')
			if ($filterWrap) {
				port_tl.fromTo(
					$filterWrap,
					{
						opacity: 0,
						y: 80,
					},
					{
						delay: 0.25,
						duration: 0.5,
						opacity: 1,
						y: 0,
					}
				)
			}
			portfolioItems.forEach((portfolioItem, i) => {
				port_tl.fromTo(
					portfolioItem,
					{ opacity: 0, y: 20 },
					{
						delay: i * 0.01,
						duration: 0.15,
						opacity: 1,
						y: 0,
						stagger: 0.2,
						ease: 'power1.out',
					}
				)
			})
		}

		jq('.filter-link').on('click', function () {
			if (portfolioItems) {
				setTimeout(() => {
					portfolioItems = document.querySelectorAll('.project-wrap')

					let port_tl = gsap.timeline({
						scrollTrigger: {
							trigger: '#projects-app',
							start: 'top center', // when the top of the trigger hits the center of the viewport
							// markers: true,
						},
					})
					portfolioItems.forEach((portfolioItem, i) => {
						port_tl.fromTo(
							portfolioItem,
							{ opacity: 0, y: 20 },
							{
								delay: i * 0.01,
								duration: 0.15,
								opacity: 1,
								y: 0,
								stagger: 0.2,
								ease: 'power1.out',
							}
						)
					})
				}, 1)
			}
		})

		//popup stuff
		html = document.getElementsByTagName('html')[0]
		document.addEventListener('keyup', function (e) {
			if (e.key === 'Escape') {
				closePopup()
			}
			if (e.key === 'ArrowRight') {
				nextSlide()
			}
			if (e.key === 'ArrowLeft') {
				previousSlide()
			}
		})
	})
</script>

<div class="projects-app">
	<div class="projects-filter-wrap">
		<div class="projects-filter">
			<p class="project-filter-label">Filter Projects:</p>
			{#each categories as category}
				<div
					class="filter-link-wrap"
					class:has-children={category.children.length !== 0}
				>
					<span
						class="filter-link"
						href={'#'}
						class:active={activeCat == category.name}
						on:click={() => (activeCat = category.name)}
					>
						{category.name}
					</span>
					{#if category.children.length !== 0}
						<ul class="filter-sub-menu">
							{#each category.children as child}
								{#if child.name !== 'Uncategorized'}
									<li
										class="filter-link"
										href={'#'}
										class:active={activeCat == child.name}
										on:click={() => (activeCat = child.name)}
									>
										{child.name}
									</li>
								{/if}
							{/each}
						</ul>
					{/if}
				</div>
			{/each}

			<span
				class="clear-link filter-link"
				class:hide-link={activeCat == 'All'}
				href={'#'}
				on:click={() => (activeCat = 'All')}
			>
				Clear
			</span>
		</div>
	</div>
	<div class="projects grid-three">
		{#each filteredProjects as project}
			{#if inArray(activeCat, project.taxonomies)}
				<div class="project-wrap grid-item" on:click={bp}>
					<div class="project-wrap-green-box">
						<div class="project-wrap-green-box-line-1" />
						<div class="project-wrap-green-box-line-2" />
						<div class="project-wrap-green-box-line-3" />
						<div class="project-wrap-green-box-line-4" />
					</div>
					<span class="fillall" on:click={openPopup(project)}>
						<span class="sr-only">Learn More</span>
					</span>
					<div
						class="project-thumbnail"
						style={`background-image: url(${project.thumb_img})`}
					>
						<div class="project-content">
							<h3>— {project.post_title}</h3>
							<div class="project-content-inner">
								{#if project.locations}
									{#each project.locations as location}
										<a href={location.url} class="location-link">
											<strong>{location.name}</strong>
										</a>
									{/each}
								{/if}
								<button on:click={openPopup(project)} class="btn btn-blue">
									<span>View Project</span>
									<div class="btn-svg-wrap">
										<svg
											xmlns="http://www.w3.org/2000/svg"
											xmlns:xlink="http://www.w3.org/1999/xlink"
											width="30px"
											height="13px"
										>
											<path
												fill-rule="evenodd"
												fill="rgb(141, 198, 63)"
												d="M22.329,0.214 L29.858,6.064 L22.284,12.142
												L22.375,7.516 L0.606,7.697 L0.515,5.021 L22.284,4.794
												L22.329,0.214 Z"
											/>
										</svg>
									</div>
								</button>
							</div>
						</div>
					</div>
				</div>
			{/if}
		{/each}
	</div>
</div>

{#if activeProject && shown == true}
	<div class="project-modal-wrap">
		<div class="project-modal-overlay" on:click={closePopup} />
		<div class="project-modal" out:fly={{ y: 15 }}>
			<button
				class="project-close-modal"
				in:fade
				out:fade
				on:click={closePopup}
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					xmlns:xlink="http://www.w3.org/1999/xlink"
					width="16px"
					height="18px"
				>
					<path
						fill-rule="evenodd"
						fill="rgb(255, 255, 255)"
						d="M14.571,17.342 L16.417,17.342 L9.449,8.423 L16.027,-0.001
						L14.155,-0.001 L8.513,7.358 L2.897,-0.001 L0.999,-0.001 L7.603,8.449
						L0.609,17.342 L2.481,17.342 L8.513,9.516 L14.571,17.342 Z"
					/>
				</svg>
			</button>
			<div class="project-img-wrap">
				<div
					class="project-img"
					style={`background-image: url('${activeProject.feat_img}')`}
				/>
				{#if nextProject}
					<div class="project-nav">
						<button on:click={previousSlide}>
							<span>‹‹</span>
							Previous Project
						</button>
						<button on:click={nextSlide}>
							Next Project
							<span>››</span>
						</button>
					</div>
				{/if}
			</div>
			<div class="row">
				<div class="project-modal-content-wrap scrollable">
					{#each activeProject.locations as location}
						<a href={location.url} class="project-location">{location.name}</a>
					{/each}

					<h2 class="project-title">{activeProject.post_title}</h2>
					<div class="project-modal-content">
						{@html activeProject.post_content}
					</div>
				</div>
				{#if activeProject.client || activeProject.highlights.length}
					<div class="scrollable project-info">
						{#if activeProject.client}
							<div>
								<h4>Client</h4>
								<p>
									{@html activeProject.client}
								</p>
							</div>
						{/if}

						{#if activeProject.highlights}
							{#each activeProject.highlights as highlight}
								<div>
									<h4>
										{@html highlight.highlight_label}
									</h4>
									<p>
										{@html highlight.highlight_content}
									</p>
								</div>
							{/each}
						{/if}
					</div>
				{/if}
			</div>
		</div>
	</div>
{/if}
